module.exports = __webpack_public_path__ + "img/yqm_.3bafd2f4.png";